import { Box, Typography } from '@mui/material';
import { t } from '../../../constants/helperTranslations';
import { useLocale } from '../../../contexts/locale.context';
import OrderItemStatus from '../../OrderItemStatus';

const POSHelper = () => {
  const { lang } = useLocale();

  return (
    <Box>
      <Typography sx={{ mb: 2 }}>{t.pos_terminal_overview[lang]}</Typography>

      <Typography>{t.pos_terminal_features[lang]}</Typography>
      <Box component="ul" sx={{ mb: 2, mt: 0 }}>
        <Typography component="li">{t.pos_terminal_features1[lang]}</Typography>
        <Typography component="li">{t.pos_terminal_features2[lang]}</Typography>
        <Typography component="li">{t.pos_terminal_features3[lang]}</Typography>
        <Typography component="li">{t.pos_terminal_features4[lang]}</Typography>
      </Box>

      <Typography sx={{ mb: 1 }}>{t.order_status_description[lang]}</Typography>
      <Box component="ul" sx={{ mb: 2, mt: 0, paddingInlineStart: 3 }}>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <OrderItemStatus status="ordered" />
          {t.order_status_description1[lang]}
        </Typography>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <OrderItemStatus status="processing" />
          {t.order_status_description2[lang]}
        </Typography>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <OrderItemStatus status="ready" />
          {t.order_status_description3[lang]}
        </Typography>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <OrderItemStatus status="complete" />
          {t.order_status_description4[lang]}
        </Typography>
      </Box>

      <Typography sx={{ mb: 2 }}>{t.order_completion[lang]}</Typography>

      <Typography sx={{ mb: 2 }}>{t.simplify_order_statuses[lang]}</Typography>

      <Typography sx={{ mb: 1 }}>{t.table_statuses[lang]}:</Typography>
      <Box component="ul" sx={{ mb: 2, mt: 0, paddingInlineStart: 3 }}>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: '2px',
              border: (t) => `2px solid ${t.palette.grey[700]}`,
              background: (t) => t.palette.grey[500],
            }}
          />
          {t.free_table[lang]}
        </Typography>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: '2px',
              border: (t) => `2px solid ${t.palette.grey[900]}`,
              background: (t) => t.palette.grey[800],
            }}
          />
          {t.booked_table[lang]}
        </Typography>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: '2px',
              border: (t) => `2px solid ${t.palette.secondary.dark}`,
              background: (t) => t.palette.secondary.main,
            }}
          />
          {t.open_active_order[lang]}
        </Typography>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: '2px',
              border: (t) => `2px solid ${t.palette.error.main}`,
              background: (t) => t.palette.error.light,
            }}
          />
          {t.dishes_ready_for_serving[lang]}
        </Typography>
        <Typography component="li" sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1 }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              borderRadius: '2px',
              border: (t) => `2px solid ${t.palette.success.main}`,
              background: (t) => t.palette.success.light,
            }}
          />
          {t.processed_unpaid_order[lang]}
        </Typography>
      </Box>

      <Box sx={{ height: 2 }} />
    </Box>
  );
};

export default POSHelper;
